import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { TimelineComment } from '../types';

type GetTimelineCommentsParams = {
    orgId: string;
    dealId: number;
    timelineId: number;
    enabled?: boolean;
};

export const getTimelineComments = async (
    orgId: string,
    dealId: number,
    timelineId: number,
): Promise<TimelineComment[]> => {
    const response = await axiosInstance.get<TimelineComment[]>(
        API_ENDPOINTS.TIMELINE_COMMENTS(orgId, dealId, timelineId),
    );
    return response.data;
};

export const useGetTimelineComments = ({
    orgId, dealId, timelineId, enabled = true,
}: GetTimelineCommentsParams) => useQuery({
    queryKey: [QUERY_KEYS.TIMELINE_COMMENTS, orgId, dealId, timelineId],
    queryFn: () => getTimelineComments(orgId, dealId, timelineId),
    enabled,
});
